var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-block"},[_c('div',{staticClass:"m-note-title",domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),_c('div',{staticClass:"m-read",domProps:{"innerHTML":_vm._s(_vm.body)}})])}
var staticRenderFns = []

export { render, staticRenderFns }